<template>
  <div class="tree">
    <TreeNode
      v-for="(node, index) in stableTreeData"
      :key="`root-${node.serialNum}-${index}`"
      :node="node"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, computed } from "vue";
import TreeNode from "./TreeNode.vue";

const props = defineProps({
  treeData: {
    type: Object,
    required: true,
  },
  openAllNode: false,
});

// 使用computed确保树数据的稳定性
const stableTreeData = computed(() => {
  return Array.isArray(props.treeData) ? props.treeData : [];
});
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
}
.tree {
  flex: 1;
  overflow: auto;
  padding: 0.14rem 0;
  position: relative;
}
.tree summary {
  outline: 0;
  padding-left: 0.9rem;
  list-style: none;
  background: linear-gradient(#bbbcbd, #bbbcbd) 0px 50%/0.68rem 0.1rem no-repeat;
}
.tree details:last-child {
  background-size: 0.1rem 2rem;
}
.tree > details:not(:last-child) > details:last-child {
  background-size: 0.1rem 100%;
}
.tree details {
  padding-left: 1.35rem;
  background: linear-gradient(#bbbcbd, #bbbcbd) 1.35rem 0px/0.1rem 100% no-repeat;
}
.tree > details {
  background: none;
  padding-left: 0;
}
.tree > details > summary {
  background: none;
}
.tree summary {
  display: flex;
  align-items: center;
  height: 2.5rem;
  font-size: 1.01rem;
  line-height: 0.74rem;
  color: rgba(0, 0, 0, 0.85);
  cursor: default;
}
.tree summary::after {
  content: "";
  position: absolute;
  left: 0.34rem;
  right: 0.34rem;
  height: 1.28rem;
  background: #eef2ff;
  border-radius: 0.27rem;
  z-index: -1;
  opacity: 0;
  transition: 0.2s;
}
.tree summary:hover::after {
  opacity: 1;
}

/* 默认样式：绿色背景带加号（已收起） */
.tree summary:not(:only-child)::before {
  content: "+";
  width: 0.95rem;
  height: 0.95rem;
  flex-shrink: 0;
  margin-right: 0.28rem;
  border: 0.03rem solid #0dcb8b;
  border-radius: 50%;
  background: #0dcb8b;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  text-align: center;
  padding: 0 0 0.1rem 0.05rem;
}

/* 已展开状态：绿色背景带减号 */
.tree details[open] > summary::before {
  content: "−";
  background: #0dcb8b;
  color: white;
}

/* 已展开状态：绿色背景带减号 */
.tree details[open] > summary:only-child::before {
  content: "+";
  background: transparent;
  color: #bbbcbd;
  border: 0.03rem solid #bbbcbd;
}

.tree summary:only-child::before {
  display: none;
}
</style>
